import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from 'react-oidc-context'
import AuthLoading from './AuthLoading'
import { HOME_PATH } from '../app/nav/menu'

/**
 * OIDC giriş callback'i (`/auth/callback`, public rota). `react-oidc-context` code→token değişimini
 * otomatik işler; tamamlanınca kullanıcı giriş öncesi hedeflediği rotaya (`state.returnTo`) yoksa
 * varsayılan landing'e — kök **Anasayfa** ({@link HOME_PATH}) — yönlendirilir (FR-015/T042). İşlem sürerken nötr yükleme gösterilir (flash yok).
 */
export default function CallbackPage() {
  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (auth.isAuthenticated) {
      const state = auth.user?.state as { returnTo?: string } | undefined
      // HOME_PATH (kök Anasayfa) — `DEFAULT_PATH` DEĞİL. `DEFAULT_PATH` (`/tickets/list`) kendi
      // yorumunda "yalnız menü modülü eşleştirmesi için korunur" diyor; giriş hedefi olarak
      // kullanılması hatasıydı ve yeni kullanıcı her girişte Bilet Talep Listesi'ne düşüyordu
      // (kullanıcı bildirimi 2026-08-26). Giriş öncesi bir hedef varsa (`returnTo`) o korunur.
      navigate(state?.returnTo ?? HOME_PATH, { replace: true })
    }
  }, [auth.isAuthenticated, auth.user, navigate])

  return <AuthLoading error={auth.error?.message} />
}
